import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://sendpi.ai';

export function SEO({ title, description, path = '/', type = 'website', noindex = false }) {
  const fullTitle = title ? `${title} — SendPI` : 'SendPI — The Communication Intelligence Layer for Both Human and AI';
  const desc = description || 'SendPI is the communication layer for both human and AI. Predict how your messages land before you send them. Score 0-100 conflict probability. Rewrite to desired outcomes. 200 free credits.';
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={`${BASE_URL}/sendpi-og.png`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={`${BASE_URL}/sendpi-og.png`} />
    </Helmet>
  );
}
